import React from "react";
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faUserFriends} from "@fortawesome/free-solid-svg-icons";
import './intro.css';


class Intro extends React.Component {


    constructor (props) {
        super(props)

        this.counter = 0;
        this.state = {
            'photo_url': Math.random() >= 0.5?'/images/header/happy_woman6.png':'/images/header/happy_woman5.png'
        }

        //bind
        this.openSearchWindow = this.openSearchWindow.bind(this)
        this.togglePhoto = this.togglePhoto.bind(this);

    }

    togglePhoto(event) {
        //event.preventDefault();
        event.stopPropagation()
        
        // fixes double click even on mobile on the first time
        if (this.counter++===1 && event.type==='click') 
            return 

        if (this.state.photo_url==='/images/header/happy_woman5.png')
            this.setState({photo_url: '/images/header/happy_woman6.png'});
        else
            this.setState({photo_url: '/images/header/happy_woman5.png'});
    }

    openSearchWindow = (e) => {
        e.preventDefault()
        if (this.props?.hideSearch || !this.props?.filters?.adults) {
            window.location = '/search'
        }
        this.props.openSearchWindow('0',false);
    }

    render() {
        const { t } = this.props;

        if (!this.props?.hideHomepageIntro && !this.props?.active || this.props?.active=='home' )
            return(
            <div className="homepage-intro-wrapper">
                <div className="homepage-intro">
                    {/*<img src={'/images/header/happy_woman5.png'} style={{display:'none'}} alt={t('homepage.intro.imageAlt')}/>
                    <img src={'/images/header/happy_woman6.png'} style={{display:'none'}} alt={t('homepage.intro.imageAlt')}/>*/}
                    <div className="homepage-intro-content" onClick={e=>{this.togglePhoto(e)}} onMouseOver={e=>{this.togglePhoto(e)}} onMouseOut={e=>{this.togglePhoto(e)}}>
                        <div className="slogan" title={t('intro.bannerTitle')}>
                            <div className="line1">{t('intro.slogan.line1')}</div>
                            <div className="line2">{t('intro.slogan.line2')}</div>
                            {this.props?.page_type!=='destination' && t('intro.slogan.line3') && t('intro.slogan.strongWord1') && t('intro.slogan.strongWord2')?
                                (
                                    <div className="line3">{t('intro.slogan.line3').split(t('intro.slogan.strongWord1'))[0]}<strong style={{color:'#fed102'}}>{t('intro.slogan.strongWord1')}</strong><br /> {t('intro.slogan.line3').split(t('intro.slogan.strongWord1'))[1].split(t('intro.slogan.strongWord2'))[0]}<strong  style={{color:'#fed102'}}>{t('intro.slogan.strongWord2')}</strong> {t('intro.slogan.line3').split(t('intro.slogan.strongWord2'))[1]}</div>
                                ):''
                            }

                            <a href="#" onClick={e=>{this.openSearchWindow(e)}} title={t('intro.searchTitle')} className="searchBoxButton" style={{display: this.props.hideSearchBox ? 'none' : ''}}>
                                <div className="searchBox" >
                                    <div title={t('intro.searchBoxTitle')} className="right" ><FontAwesomeIcon icon={faSearch} style={{color: '#555', fontSize: '1em',  margin: '0 0.3em'}} />{t('intro.searchPlaceholder')}</div>
                                    <div title={t('intro.passengersTitle')} className="left"><FontAwesomeIcon icon={faUserFriends} style={{color: '#29bbd8', fontSize: '1em',  margin: '0 0.3em'}} /> {
                                        this.props?.filters?.teens + this.props?.filters?.children + this.props?.filters?.infants == 0 ?
                                        t('filters.pax.adultsCount', { count: this.props?.filters?.adults }):
                                        this.props?.filters?.adults==2 && this.props?.filters?.children + this.props?.filters?.infants > 0 && this.props?.filters?.teens == 0?
                                            `${t('filters.pax.couple')}+${this.props?.filters?.children*1 + this.props?.filters?.infants*1}`:
                                            (this.props?.filters?.adults*1 + this.props?.filters?.teens*1 + this.props?.filters?.children*1 + this.props?.filters?.infants*1)>0?
                                                t('filters.pax.passengersCount', { count: this.props?.filters?.adults*1 + this.props?.filters?.teens*1 + this.props?.filters?.children*1 + this.props?.filters?.infants*1 }):
                                                t('filters.pax.passengersCount', { count: 2 })
                                    }</div>
                                </div></a>
                            <div className="line4" style={{marginTop: this.props.hideSearchBox ? '120px' : 'inherit'}}></div>
                        </div>
                        {/*<div className="image">
                            <img src={this.state.photo_url} alt={t('homepage.intro.bannerImageAlt')}></img>
                        </div>*/}
                    </div>
                </div>
                {/*<div style={{height:'150px', width:'100%', marginTop:'20px',  backgroundImage:'url(/images/promotions/black-friday-banner-2000x150.jpg)'}}></div>*/}
            </div>
            )
        else
            return (<></>);
    }
}

export default withTranslation()(Intro)